import { render, staticRenderFns } from "./returning-act-dialog.vue?vue&type=template&id=5d1d7d82&scoped=true&"
import script from "./returning-act-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./returning-act-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./returning-act-dialog.vue?vue&type=style&index=0&id=5d1d7d82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d7d82",
  null
  
)

export default component.exports